var map = {
	"./1.webp": [
		795
	],
	"./1_sm.webp": [
		796
	],
	"./2.webp": [
		797
	],
	"./2_sm.webp": [
		798
	],
	"./3.webp": [
		799
	],
	"./3_sm.webp": [
		800
	],
	"./4.webp": [
		801
	],
	"./4_sm.webp": [
		802
	],
	"./blog-pics/ad-pic1.webp": [
		809
	],
	"./blog-pics/ad-pic2.webp": [
		810
	],
	"./blog-pics/ad-pic3.webp": [
		811
	],
	"./blog-pics/ad-pic4.webp": [
		813
	],
	"./blog-pics/ad-pic5.webp": [
		814
	],
	"./blog-pics/claude-pic.webp": [
		812
	],
	"./book_cover.webp": [
		755
	],
	"./book_cover2.webp": [
		757
	],
	"./booknotes_cover.webp": [
		758
	],
	"./booknotes_cover152x200.webp": [
		761
	],
	"./booknotes_cover42x55.webp": [
		759
	],
	"./booknotes_cover73x97.webp": [
		760
	],
	"./bookset_cover152x200.webp": [
		774
	],
	"./bookset_cover42x55.webp": [
		772
	],
	"./bookset_cover73x97.webp": [
		773
	],
	"./category-donation-bg-ffa.webp": [
		2543,
		131
	],
	"./category-donation-bg-ocean.webp": [
		2544,
		132
	],
	"./category_cover_Bahai.webp": [
		3872,
		133
	],
	"./category_cover_Buddhist.webp": [
		3873,
		134
	],
	"./category_cover_Children.webp": [
		3874,
		135
	],
	"./category_cover_Christian.webp": [
		3875,
		136
	],
	"./category_cover_Confucian.webp": [
		3876,
		137
	],
	"./category_cover_Drama.webp": [
		3877,
		138
	],
	"./category_cover_Hindu.webp": [
		3878,
		139
	],
	"./category_cover_History.webp": [
		3879,
		140
	],
	"./category_cover_Ideas.webp": [
		3880,
		141
	],
	"./category_cover_Islam.webp": [
		3881,
		142
	],
	"./category_cover_Jainism.webp": [
		3882,
		143
	],
	"./category_cover_Judaism.webp": [
		3883,
		144
	],
	"./category_cover_New.webp": [
		3884,
		145
	],
	"./category_cover_Novels.webp": [
		3885,
		146
	],
	"./category_cover_Religion.webp": [
		3886,
		147
	],
	"./category_cover_Science.webp": [
		3887,
		148
	],
	"./category_cover_ShortStories.webp": [
		3888,
		149
	],
	"./category_cover_Tao.webp": [
		3889,
		150
	],
	"./category_cover_Verse.webp": [
		3890,
		151
	],
	"./category_cover_Zoroastrian.webp": [
		3891,
		152
	],
	"./category_dummy_cover.webp": [
		3892,
		153
	],
	"./collection_cover.webp": [
		762
	],
	"./collection_cover152x200.webp": [
		765
	],
	"./collection_cover42x55.webp": [
		763
	],
	"./collection_cover73x97.webp": [
		764
	],
	"./compilation_cover42x55.webp": [
		779
	],
	"./compilation_cover73x97.webp": [
		780
	],
	"./compilation_default_cover42x55.webp": [
		781
	],
	"./compilation_default_cover73x97.webp": [
		782
	],
	"./compilation_shared_cover42x55.webp": [
		783
	],
	"./compilation_shared_cover73x97.webp": [
		784
	],
	"./default_book_image.webp": [
		756
	],
	"./donation-bg-ffa.webp": [
		806
	],
	"./dummy_book_cover.webp": [
		767
	],
	"./empty_book_cover.webp": [
		766
	],
	"./empty_folder.webp": [
		804
	],
	"./faq-pic-ffa.webp": [
		807
	],
	"./faq-pic-ocean.webp": [
		808
	],
	"./firework.webp": [
		3893,
		154
	],
	"./hr-style.webp": [
		3894,
		155
	],
	"./hr2.webp": [
		3895,
		156
	],
	"./hr2_night.webp": [
		3896,
		157
	],
	"./iMac-ocean.webp": [
		791
	],
	"./ico-appstore.webp": [
		3897,
		158
	],
	"./ico-playmarket.webp": [
		3898,
		159
	],
	"./icon_comp.webp": [
		3899,
		160
	],
	"./oceanOfLights-logo.webp": [
		3900,
		161
	],
	"./pic-assessment-main-small.webp": [
		2432,
		162
	],
	"./pic-assessment-main.webp": [
		2431,
		163
	],
	"./pic-booklet1.webp": [
		788
	],
	"./pic-booklet2.webp": [
		789
	],
	"./pic-booklet3.webp": [
		790
	],
	"./pic-chrome.webp": [
		3901,
		164
	],
	"./pic-edge.webp": [
		3902,
		165
	],
	"./pic-firework.webp": [
		785
	],
	"./pic-sales.webp": [
		3903,
		166
	],
	"./pic-section2-bg.webp": [
		3904,
		167
	],
	"./pic-slide-bg1.webp": [
		3905,
		168
	],
	"./pic-slide-bg2.webp": [
		3906,
		169
	],
	"./pic-slide-item1.webp": [
		786
	],
	"./pic-slide-item3.webp": [
		787
	],
	"./pic-va-success.webp": [
		2524,
		170
	],
	"./promo.webp": [
		792
	],
	"./promo_portrait.webp": [
		793
	],
	"./promo_sm.webp": [
		794
	],
	"./pttrn.webp": [
		2404,
		171
	],
	"./pttrn_gray.webp": [
		3907,
		172
	],
	"./shortsummary_icon.webp": [
		3908,
		173
	],
	"./study_course_bg.webp": [
		3909,
		174
	],
	"./studyclass_cover.webp": [
		775
	],
	"./studyclass_cover152x200.webp": [
		778
	],
	"./studyclass_cover42x55.webp": [
		776
	],
	"./studyclass_cover73x97.webp": [
		777
	],
	"./studycourse_cover.webp": [
		768
	],
	"./studycourse_cover152x200.webp": [
		771
	],
	"./studycourse_cover42x55.webp": [
		769
	],
	"./studycourse_cover73x97.webp": [
		770
	],
	"./tick_lgreen.webp": [
		3910,
		175
	],
	"./voc_assessment.webp": [
		803
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2975;
module.exports = webpackAsyncContext;